import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { coreService } from 'network-utils';
import { SmallLoader } from 'learning-panel-components';
import { selectToken } from '@redux/slices/userSlice';
import { useGetChallengeUsersLeaderboard } from '@queries/core/challenges';
import UserLeaderboard, { UserData } from './userLeaderboard/userLeaderboard';

const UserLeaderboardContainer: FC<{ challengeUuid?: string }> = (props: { challengeUuid?: string }) => {
    const { challengeUuid } = props;
    const token = useSelector(selectToken);
    const [allUsers, setAllUsers] = useState<UserData[]>([]);
    const [currentUser, setCurrentUser] = useState<UserData | null>(null);
    const { data, isLoading } = useGetChallengeUsersLeaderboard(token, false, challengeUuid);

    const mapUser = (user: coreService.UserLeaderboard) => ({
        rank: user.rank,
        nickname: user.nicknameOrEmail,
        score: Number(user.points),
        profilePicture: user.profilePicture,
        teams: user.teams
    });

    useEffect(() => {
        if (!data) return;
        const { currentUser, topTen } = data.usersLeaderboard;
        setCurrentUser(mapUser(currentUser));
        const users = topTen.map((user: coreService.UserLeaderboard) => mapUser(user));
        setAllUsers(users);
    }, [data]);

    return isLoading ? (
        <SmallLoader size="100px" />
    ) : (
        currentUser && (
            <UserLeaderboard
                currentUser={currentUser}
                users={allUsers}
                onLoadMore={() => undefined}
                hasMore={false}
                tableHeight="32rem"
                currentUserTop="17.2rem"
                showTeamsNames
                isTournament={false}
            />
        )
    );
};

export default UserLeaderboardContainer;
